import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'mytc-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ButtonComponent {
  @Input() id: string;
}
